var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filterWrapper textSearch" }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        {
          staticClass: "floating-placeholder lgrid-noWrap",
          class: { focused: _vm.search || _vm.focused },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "lgrid-column-noGutter-center-noWrap-equalHeight lcol",
            },
            [
              _c(
                "div",
                { staticClass: "placeholder", on: { click: _vm.focus } },
                [_vm._v("\n          " + _vm._s(_vm.name) + "\n        ")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.tempSearch,
                    expression: "tempSearch",
                    modifiers: { lazy: true },
                  },
                ],
                ref: "textInput",
                attrs: { type: "text", name: _vm.id },
                domProps: { value: _vm.tempSearch },
                on: {
                  focus: _vm.focus,
                  blur: _vm.blur,
                  submit: _vm.submit,
                  keydown: function ($event) {
                    _vm.lastSearchValue = null
                  },
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.submit.apply(null, arguments)
                  },
                  change: function ($event) {
                    _vm.tempSearch = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm.enabledResetButton
            ? _c(
                "button",
                {
                  staticClass: "no-button textSearch--submit",
                  on: {
                    click: function ($event) {
                      _vm.search = ""
                    },
                  },
                },
                [_c("i", { staticClass: "dsio-close" })]
              )
            : _vm._e(),
          !_vm.enabledResetButton
            ? _c(
                "button",
                {
                  staticClass: "no-button textSearch--submit",
                  on: {
                    click: function () {
                      !_vm.tempSearch ? _vm.focus() : _vm.submit()
                    },
                  },
                },
                [_c("i", { staticClass: "dsio-search-light" })]
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }